const imageTransform = (width = 2000, height = null) => `@transform(
    format: "webp",
    quality: 80,
    ${width ? `width:${width}` : ''},
    ${height ? `height:${height}` : ''},
    immediately: true
) {
    title
    url
    srcset(sizes:["${width / 6.25}w", "${width / 3.125}w", "${width / 1.5625}w", "${width / 0.78125}w", "${width}w"]),
    width
    height
}`;

export default (name = 'flexible') => `
    ${name} {
        __typename,
        ... on ${name}_quoteBig_BlockType {
            flexibleQuoteBig,
            flexibleQuoteAuthor
            anchorTitle
        }
        ... on ${name}_quoteSmall_BlockType {
            flexibleQuoteSmall,
            flexibleQuoteAuthor
            anchorTitle
        }
        ... on ${name}_featuredContent_BlockType {
            featuredContentTitle,
            featuredContentText,
            anchorTitle
            iconPickerCharacters {
                inline
            }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_msDynamicsFormSection_BlockType {
            msDynamicsId,
            msDynamicsBlockId,
            msDynamicsWebsiteId,
            msDynamicsHostname
            anchorTitle
        }
        ... on ${name}_video_BlockType {
            anchorTitle
            video: flexibleVideo {
                ... on flexibleVideoBlock_Entry {
                    cover ${imageTransform()}
                    videoUrl
                }
            }
        }
        ... on ${name}_image_BlockType {
            anchorTitle
            image: flexibleImage ${imageTransform()}
        }
        ... on ${name}_imageVideo_BlockType {
            anchorTitle
            image: flexibleImage ${imageTransform()}
            video: flexibleVideo {
                ... on flexibleVideoBlock_Entry {
                    cover ${imageTransform()}
                    videoUrl
                }
            }
        }
        ... on ${name}_podcastImage_BlockType {
            anchorTitle
            podcast: flexiblePodcast {
                ... on flexiblePodcastBlock_Entry {
                    cover ${imageTransform()}
                    podcastUrl,
                    podcastCta
                }
            }
            image: flexibleImage ${imageTransform()}
        }
        ... on ${name}_podcastEmbedded_BlockType {
            anchorTitle
            embeddedPodcast: flexibleEmbeddedPodcast
        }
        ... on ${name}_statistic_BlockType {
            anchorTitle
            statistic: flexibleStatistic {
                ... on flexibleStatisticBlock_Entry {
                    bigTitle,
                    text
                }
            }
        }
        ... on ${name}_wysiwyg_BlockType {
            anchorTitle
            wysiwyg: flexibleWysiwig
        }
        ... on ${name}_imageImage_BlockType {
            anchorTitle
            images: flexibleImages {
                ... on flexibleImagesBlock_Entry {
                    left ${imageTransform()}
                    right ${imageTransform()}
                    leftcredits,
                    rightcredits
                }
            }
        }
        ... on ${name}_imageCredits_BlockType {
            anchorTitle
            image: flexibleImageCredits {
                ... on flexibleImageCreditsBlock_Entry {
                    credits
                    image ${imageTransform()}
                }
            }
        }
        ... on ${name}_ad_BlockType {
            ad: flexibleAdSelection @adEntryToId
        }
        ... on ${name}_featuredPosts_BlockType {
            anchorTitle
            featuredContentTitle
            featuredContentText: flexibleWysiwig
            selectedPosts: selectedPosts {
                id,
                title,
                uri,
                ... on blog_Entry {
                    day: postDate @formatDateTime (format: "d"),
                    month: postDate @formatDateTime (format: "n"),
                    year: postDate @formatDateTime (format: "Y"),
                    category: blogCategory { title },
                    cover: blogCover ${imageTransform(800, 420)}
                }
                ... on recette_Entry {
                    category: recetteCategory { title },
                    cover: recetteCover ${imageTransform(800, 420)}
                }
            },
            typesDeContenus
            featuredContentLink,
            featuredContentLinkText,
            featuredContentLinkNewTab
        }
        ... on ${name}_accordions_BlockType {
            anchorTitle
            featuredContentTitle,
            fullWidth,
            children {
                ... on ${name}_accordionSection_BlockType {
                    anchorTitle
                    featuredContentTitle,
                    flexibleWysiwig
                }
            }
        }
        ... on ${name}_featuredPostBanner_BlockType {
            anchorTitle
            featuredContentTitle,
            featuredContentText,
            featuredContentMainLink,
            featuredContentLink,
            featuredContentMainLinkNewTab,
            featuredContentLinkNewTab,
            featuredContentMainLinkText,
            featuredContentLinkText,
            flexibleImage ${imageTransform(800)}
        }
        ... on ${name}_featuredPostsGrid_BlockType {
            anchorTitle
            featuredContentTitle
            featuredContentText
            link: flexibleLink {
                url
                text
                type
            }
            selectedPosts: selectedPostsMultiple {
                id
                title
                uri
                typeHandle
                ... on product_Entry {
                        cover: productCover ${imageTransform(800, 420)}
                }
                ... on blog_Entry {
                        day: postDate @formatDateTime (format: "d"),
                        month: postDate @formatDateTime (format: "n"),
                        year: postDate @formatDateTime (format: "Y"),
                        category: blogCategory { title },
                        cover: blogCover ${imageTransform(800, 420)}
                }
                ... on recette_Entry {
                        category: recetteCategory { title },
                        cover: recetteCover ${imageTransform(800, 420)}
                }
            },
            typesDeContenus
        }
        ... on ${name}_sentierDesActualites_BlockType {
            featuredContentTitle
            featuredContentText
            selectedBlogs {
                id
                title
                uri
                typeHandle
                ... on blog_Entry {
                    day: postDate @formatDateTime (format: "d"),
                    month: postDate @formatDateTime (format: "n"),
                    year: postDate @formatDateTime (format: "Y"),
                    category: blogCategory { title },
                    cover: blogCover ${imageTransform(800, 420)}
                }
            }
            blogCategory { id }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_sentierDeLaGastronomie_BlockType {
            featuredContentTitle
            featuredContentText
            selectedRecipes {
                id
                title
                uri
                typeHandle
                ... on recette_Entry {
                        category: recetteCategory { title },
                        cover: recetteCover ${imageTransform(800, 420)}
                }
            }
            recetteCategory { id }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_sentierDesDecouvertes_BlockType {
            featuredContentTitle
            featuredContentText
            selectedPosts: selectedPostsMultiple {
                id
                title
                uri
                typeHandle
                ... on product_Entry {
                        cover: productCover ${imageTransform(800, 420)}
                }
                ... on blog_Entry {
                        day: postDate @formatDateTime (format: "d"),
                        month: postDate @formatDateTime (format: "n"),
                        year: postDate @formatDateTime (format: "Y"),
                        category: blogCategory { title },
                        cover: blogCover ${imageTransform(800, 420)}
                }
                ... on recette_Entry {
                        category: recetteCategory { title },
                        cover: recetteCover ${imageTransform(800, 420)}
                }
            },
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_sentierDesEconomies_BlockType {
            featuredContentTitle
            featuredContentText
            selectedDiscounts {
                id
                title,
                status,
                ... on discount_Entry {
                    prize: discountPrize,
                    unit: discountUnit,
                    url: discountUrl,
                    discountStatus: discountStatus,
                    ingredients: discountIngredients { id, slug, title },
                    grocery: discountGrocery {
                        ... on superStore_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        },
                        ... on saleSpecialist_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        },
                        ... on specializedGrocery_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        }
                    }
                }
            }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_sentierDeLAgrotourisme_BlockType {
            featuredContentTitle
            featuredContentText
            categoryOrTag { id },
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_newsletter_BlockType {
            anchorTitle
            id
        }
        ... on ${name}_featuredPostsRelatedTo_BlockType {
            anchorTitle
            featuredContentTitle
            featuredContentText: flexibleWysiwig
            categoryOrTag { id },
            featuredContentLink,
            featuredContentLinkText,
            featuredContentLinkNewTab
        }
        ... on ${name}_featuredPostsGridRelatedTo_BlockType {
            anchorTitle
            featuredContentTitle
            featuredContentText
            link: flexibleLink {
                url
                text
                type
            }
            categoryOrTag { id }
        }
        ... on ${name}_productSelection_BlockType {
            anchorTitle
            featuredContentTitle
            featuredContentText
            products: selectedProducts {
                id,
                title,
                uri,
                ... on product_Entry {
                    color,
                    ingredients: productIngredients { id, title },
                    cover: productCover ${imageTransform(500)}
                }
            }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_faq_BlockType {
            anchorTitle
            id
        }
        ... on ${name}_discountsSelection_BlockType {
            featuredContentTitle
            featuredContentText
            anchorTitle
            selectedDiscounts {
                id
                title,
                status,
                ... on discount_Entry {
                    prize: discountPrize,
                    unit: discountUnit,
                    url: discountUrl,
                    discountStatus: discountStatus,
                    ingredients: discountIngredients { id, slug, title },
                    grocery: discountGrocery {
                        ... on superStore_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        },
                        ... on saleSpecialist_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        },
                        ... on specializedGrocery_Entry {
                            id,
                            postDate,
                            title,
                            slug,
                            logo: groceryLogo ${imageTransform(500)}
                        }
                    }
                }
            }
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_discountsRelatedTo_BlockType {
            featuredContentTitle
            featuredContentText
            anchorTitle
            categoryOrTag { id },
            link: flexibleLink {
                url
                text
                type
            }
        }
        ... on ${name}_bioCta_BlockType {
            anchorTitle
        }

        ... on ${name}_mapGroceries_BlockType {
            locationCtaPage
            locationSaleSpecialistPlaceHolder
            locationCtaMap
        }

        ... on ${name}_mailchimpForm_BlockType {
            mailchimpListId
            mailchimpApiKey
            mailchimpError
            mailchimpSuccess
            mailchimpAlreadySubscribed
            mailchimpTags
            children {
                ... on  ${name}_mailchimpFieldOptions_BlockType {
                    __typename
                    mailchimpFieldMergeTag
                    mailchimpFieldPlaceholder
                    mailchimpFieldLabel
                    mailchimpFieldInstructions
                    mailchimpFieldRequired
                }
                ... on  ${name}_mailchimpGroup_BlockType {
                    __typename
                    mailchimpGroupId
                }
            }
        }
    }
`;

export { imageTransform };
